import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class WhatsappService {
  getUserList(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/user/list", params);
  }
  getUserMessages(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/user/messages", params);
  }
  sendMessage(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/message/send", body);
  }
  sendGenericTemplateMessage(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/message/template/send-generic", body);
  }
  getTemplates() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/message/templates");
  }
  getTemplateStatus(sid) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "whatsapp/message/template/status", { sid });
  }
}

export default new WhatsappService();
